import { useSelector } from "react-redux";
import { phoneNumberFormatting, getName } from "js/formatting";
import { useTranslation } from "react-i18next";

import CardWithFields from "components/General/CardWithFields";

export default function OwnerCard({ owners }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const loggedInOwner = owners.find(
    (owner) => owner.person.taxId === user.identityNumber
  );

  const additionalOwners = owners.filter(
    (owner) => owner.person.taxId !== user.identityNumber
  );

  const { addressLine1, addressLine2, city, postalCode, state } =
    loggedInOwner.address;
  const { phoneNumber } = loggedInOwner.phone;
  const { address: emailAddress } = loggedInOwner.email;

  return (
    <CardWithFields
      additionalContent={
        additionalOwners.length > 0 && (
          <>
            <hr />
            <div className="px-4 pb-4 overflow-hidden h-20 mt-4 md:h-auto md:mt-0 xl:px-6 xl:pb-6">
              <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:gap-6">
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("CustomerPolicyDetails-annuity-additional-owners")}
                  </div>

                  {additionalOwners.map((owner) => (
                    <div
                      key={owner.person?.personId}
                      className="text-sm text-theme-text-secondary font-semibold"
                    >
                      {getName(owner.person)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )
      }
      ariaLabel={t("CustomerPolicyDetails-annuity-owner-aria-label")}
      cardTitle={t("CustomerPolicyDetails-annuity-owner-card-title")}
      cardFields={[
        {
          title: t("CustomerPolicyDetails-annuity-owner"),
          value: getName(loggedInOwner.person),
        },
        {
          title: t("CustomerPolicyDetails-annuity-owner-address"),
          value: (
            <>
              {addressLine1}
              <p>{addressLine2}</p>
              {`${city}, ${state} ${postalCode.substring(0, 5)}`}
            </>
          ),
        },
        {
          title: t("CustomerPolicyDetails-annuity-owner-phone"),
          value: (
            <a href={`tel:+1${phoneNumber}`}>
              {phoneNumberFormatting(phoneNumber)}
            </a>
          ),
        },
        {
          title: t("CustomerPolicyDetails-annuity-owner-email"),
          value: (
            <a href={`mailto:${emailAddress}`} className="break-all">
              {emailAddress}
            </a>
          ),
        },
      ]}
    />
  );
}
